import { KYCStatus } from '@/common/types'
import { create } from 'zustand'

interface State {
    kyc: KYCStatus | null
    setKyc: (status: KYCStatus | null) => void
    kycComplete: boolean
    setKycComplete: (complete: boolean) => void
    completionTimestamp: number | null
    setCompletionTimestamp: (timestamp: number | null) => void
}

const useKycStore = create<State>((set) => ({
    kyc: null,
    setKyc: (status: KYCStatus | null) => set({ kyc: status }),
    kycComplete: false,
    setKycComplete: (complete: boolean) => set({ kycComplete: complete }),
    completionTimestamp: null,
    setCompletionTimestamp: (timestamp: number | null) => set({ completionTimestamp: timestamp }),
}))

export default useKycStore
